import { useEffect, useMemo, useState } from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import userStore from '@/store/admin/userStore';

const LS_USER = 'adminUserInfo';
const LS_PERMS = 'adminPermissions';

export default function SessionExpired() {
    const location = useLocation();
    const navigate = useNavigate();
    const [secondsLeft, setSecondsLeft] = useState(3);

    const { code, message } = useMemo(() => {
        const sp = new URLSearchParams(location.search);
        const codeStr = sp.get('code') || '';
        const msg = sp.get('msg') || '';
        const parsedCode = codeStr ? Number(codeStr) : undefined;
        return {
            code: Number.isFinite(parsedCode as any) ? parsedCode : undefined,
            message: msg || undefined,
        };
    }, [location.search]);

    useEffect(() => {
        try {
            userStore.clearUser();
        } catch {
            // ignore
        }
        try {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('Admin-Token');
            localStorage.removeItem(LS_USER);
            localStorage.removeItem(LS_PERMS);
        } catch {
            // ignore
        }
    }, []);

    useEffect(() => {
        const t = window.setInterval(() => {
            setSecondsLeft((s) => (s <= 1 ? 0 : s - 1));
        }, 1000);
        return () => window.clearInterval(t);
    }, []);

    useEffect(() => {
        if (secondsLeft <= 0) {
            navigate('/login');
        }
    }, [secondsLeft, navigate]);

    const title = code === 403 || code === 401
        ? 'No Permission'
        : 'Session Expired';

    const detail = message
        || (code === 403 || code === 401 ? 'No permission to operate.' : 'Login has expired, please login again.');

    return (
        <Container maxWidth="sm" sx={{ py: 8 }}>
            <Paper elevation={2} sx={{ p: 4 }}>
                <Typography variant="h5" fontWeight={700} gutterBottom>
                    {title}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {detail}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Redirecting to login in {secondsLeft}s...
                </Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button variant="contained" onClick={() => navigate('/login')}>
                        Go to Login
                    </Button>
                    <Button variant="outlined" onClick={() => navigate('/')}> 
                        Back to Home
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}
